/** Set to true to re-enable Admin → Nebula Insights (route + sidebar). */
export const NEBULA_INSIGHTS_ENABLED = true;

/**
 * Nova Distro app URL. The sidebar opens this with a Nova-issued token in the
 * URL fragment (`#t=<jwt>`). Override per environment via REACT_APP_NOVADISTRO_URL.
 */
export const NOVADISTRO_URL =
  process.env.REACT_APP_NOVADISTRO_URL || "https://mylinks.novadistro.io/login";

/** Admin Distro applications that accept the same Nova-issued JWT handoff. */
export const MIGRATE_CATALOG_URL =
  process.env.REACT_APP_MIGRATE_CATALOG_URL || "https://migrate.novadistro.io/login/";

export const MIGRATION_ADMIN_URL =
  process.env.REACT_APP_MIGRATION_ADMIN_URL || "http://migrate.novadistro.io/admin";

export const FAN_MANAGER_ADMIN_URL =
  process.env.REACT_APP_FAN_MANAGER_ADMIN_URL || "https://fanmanager.novadistro.io/admin";

export const NOVADISTRO_VAULT_URL =
  process.env.REACT_APP_NOVADISTRO_VAULT_URL || "https://vault.novadistro.io/login/";

export const FAN_MANAGER_URL =
  process.env.REACT_APP_FAN_MANAGER_URL || "https://fanmanager.novadistro.io/login/";
